import React from 'react';
import { Button } from './ui/button';

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-r from-gray-50 to-gray-100 py-20">
      <div className="absolute inset-0 bg-black bg-opacity-10"></div>
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-15"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBidXNpbmVzc3xlbnwwfHx8fDE3NTMyNDI3MjR8MA&ixlib=rb-4.1.0&q=85')`
        }}
      ></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Mitz Traders
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 mb-4 max-w-3xl mx-auto">
            Your Trusted Partner in Global Trading & E-commerce Solutions
          </p>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            Specialising in import/export, product sourcing, and retail support across the UK and beyond. 
            Experience reliability, fast delivery, and customer-first service with every transaction.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              onClick={() => window.open('https://mitzcart.com', '_blank')}
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg font-semibold transition-all duration-200 transform hover:scale-105"
            >
              Explore MitzCart.com
            </Button>
            <Button 
              onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
              variant="outline"
              size="lg"
              className="border-gray-400 text-gray-700 hover:bg-gray-50 px-8 py-4 text-lg font-semibold transition-all duration-200"
            >
              Learn More
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;